import { render, staticRenderFns } from "./UserReview.vue?vue&type=template&id=85731550&"
import script from "./UserReview.vue?vue&type=script&lang=ts&"
export * from "./UserReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports